<template lang="pug">
b-modal#addVip(
  ref="addVip"
  :title="$t('ui.combine.add_vip')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group.mb-0
      label {{ $t('ui.vip_name') }}
      i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_vip_name')")
      DebounceInput(
        size="sm"
        ref="vip_name"
        required
        type="text"
        :dirty="$v.vip_name.$dirty"
        :error="$v.vip_name.$error"
        v-model.trim.lazy="$v.vip_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.vip_name" :name="$t('ui.vip_name')")
    b-form-group(:label="$t('ui.deposit')").mb-0
      DebounceInput(
        size="sm"
        ref="deposit"
        type="text"
        :dirty="$v.deposit.$dirty"
        :error="$v.deposit.$error"
        v-model.trim.lazy="$v.deposit.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.deposit" :name="$t('ui.deposit')")
    b-form-group(:label="$t('ui.turnover')").mb-0
      DebounceInput(
        ref="turnover"
        size="sm"
        required
        type="text"
        :dirty="$v.turnover.$dirty"
        :error="$v.turnover.$error"
        v-model.trim.lazy="$v.turnover.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.turnover" :name="$t('ui.turnover')")
    b-form-group(:label="$t('ui.maintain_deposit')").mb-0
      DebounceInput(
        size="sm"
        ref="maintain_deposit"
        type="text"
        :dirty="$v.maintain_deposit.$dirty"
        :error="$v.maintain_deposit.$error"
        v-model.trim.lazy="$v.maintain_deposit.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.maintain_deposit" :name="$t('ui.maintain_deposit')")
    b-form-group(:label="$t('ui.maintain_turnover')").mb-0
      DebounceInput(
        ref="maintain_turnover"
        size="sm"
        required
        type="text"
        :dirty="$v.maintain_turnover.$dirty"
        :error="$v.maintain_turnover.$error"
        v-model.trim.lazy="$v.maintain_turnover.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.maintain_turnover" :name="$t('ui.cturnover')")
    //- div.row
    //-   div.col-sm-12.col-md-3.col-lg-3
    //-     b-form-group(:label="$t('ui.is_default')").mb-2
    //-       div.d-flex
    //-         label.switch.switch-label.switch-info.m-0
    //-           input.switch-input(
    //-             type="checkbox"
    //-             required
    //-             :dirty="$v.is_default.$dirty"
    //-             :error="$v.is_default.$error"
    //-             v-model.trim.lazy="$v.is_default.$model"
    //-             :disabled="loading"
    //-           )
    //-           span.switch-slider(:data-checked='on' :data-unchecked='off')
    //-   div.col-sm-12.col-md-3.col-lg-3
    //-     b-form-group(:label="$t('ui.default_order')").mb-2
    //-       div.d-flex
    //-         label.switch.switch-label.switch-info.m-0
    //-           input.switch-input(
    //-             type="checkbox"
    //-             required
    //-             :dirty="$v.default_order.$dirty"
    //-             :error="$v.default_order.$error"
    //-             v-model.trim.lazy="$v.default_order.$model"
    //-             :disabled="loading"
    //-           )
    //-           span.switch-slider(:data-checked='on' :data-unchecked='off')
    //-   div.col-sm-12.col-md-6.col-lg-6(v-if="!default_order")
    //-     b-form-group(:label="$t('ui.item_order')").mb-0
    //-       CMSBannerCount(
    //-         ref="item_order"
    //-         size="sm"
    //-         required
    //-         type="array"
    //-         :dirty="$v.item_order.$dirty"
    //-         :error="$v.item_order.$error"
    //-         v-model.trim.lazy="$v.item_order.$model"
    //-         bType="vip"
    //-         :disabled="loading"
    //-       )
    //-       ValidateResult(:value="$v.item_order" :name="$t('ui.item_order')")
    b-form-group(:label="$t('ui.reward_type')").mb-0
      VipRewardType(
        ref="reward_type"
        size="sm"
        required
        type="array"
        :dirty="$v.reward_type.$dirty"
        :error="$v.reward_type.$error"
        v-model.trim.lazy="$v.reward_type.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.reward_type" :name="$t('ui.reward_type')")
    template(v-if="reward_type == 'CASH'")
      b-form-group(:label="$t('ui.cash')").mb-0
        DebounceInput(
          size="sm"
          ref="cash"
          required
          type="text"
          :dirty="$v.cash.$dirty"
          :error="$v.cash.$error"
          v-model.trim.lazy="$v.cash.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.cash" :name="$t('ui.cash')")
      b-form-group(:label="$t('ui.campaign_id')").mb-0
        CampaignLookup(
          :operatorID="operatorID"
          size="sm"
          ref="campaign_id"
          required
          type="array"
          :dirty="$v.campaign_id.$dirty"
          :error="$v.campaign_id.$error"
          v-model.trim.lazy="$v.campaign_id.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.campaign_id" :name="$t('ui.campaign_id')")
    template(v-if="reward_type == 'CS'")
      b-form-group(:label="$t('ui.cs')").mb-0
        DebounceInput(
          size="sm"
          ref="cs"
          required
          type="text"
          :dirty="$v.cs.$dirty"
          :error="$v.cs.$error"
          v-model.trim.lazy="$v.cs.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.cs" :name="$t('ui.cs')")
      b-form-group(:label="$t('ui.social_platform')").mb-0
        SocialPlatformLookup(
          size="sm"
          ref="social_platform"
          required
          type="array"
          :dirty="$v.social_platform.$dirty"
          :error="$v.social_platform.$error"
          v-model.trim.lazy="$v.social_platform.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.social_platform" :name="$t('ui.social_platform')")
    b-form-group
      .alert.alert-secondary.alert-has-icon.text-dark
        .alert-icon
          i.far.fa-lightbulb
        .alert-body
          .alert-title {{ $t('ui.info') }}
          div {{ $t('message.vip_info1') }}
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import CMSBannerCount from "@/library/CMSBannerCount";
import VipRewardType from "@/library/VipRewardType";
import SocialPlatformLookup from "@/library/SocialPlatformLookup";
import CampaignLookup from "@/library/CampaignLookup";
// const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const alphaNumWithUnicode = helpers.regex("alphaNumWithUnicode", /^([^\u0000-\u007F]|[A-Za-z0-9\s])+$/i);
const atLeastOneProvider = (value) => value.length > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    CMSBannerCount,
    VipRewardType,
    SocialPlatformLookup,
    CampaignLookup
  },
  props: {
    operatorID: {
      type: String,
      default: ""
    }
    // item: {
    //   type: Object
    // },
  },
  data() {
    return {
      vip_name: "",
      deposit: 0,
      turnover: 0,
      maintain_deposit: 0,
      maintain_turnover: 0,
      is_default: true,
      default_order: true,
      item_order: 0,
      reward_type: "",
      cash: 0,
      campaign_id: "",
      cs: "",
      social_platform: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
  },
  validations: {
    vip_name: {
      required,
      alphaNumWithUnicode,
      minLength: minLength(1),
      maxLength: maxLength(20)
    },
    deposit: {
      decimal,
      minValue(value) {
        if (this.turnover == 0) {
          return minValue(1)(value)
        } else {
          return minValue(0)(value)
        }
      },
      required: requiredIf(function () {
        return this.turnover == 0;
      })
    },
    turnover: {
      decimal,
      minValue(value) {
        if (this.deposit == 0) {
          return minValue(1)(value)
        } else {
          return minValue(0)(value)
        }
      },
      required: requiredIf(function () {
        return this.deposit == 0;
      })
    },
    maintain_deposit: {
      decimal,
      minValue(value) {
        if (this.maintain_turnover == 0) {
          return minValue(1)(value)
        } else {
          return minValue(0)(value)
        }
      },
      required: requiredIf(function () {
        return this.maintain_turnover == 0;
      })
    },
    maintain_turnover: {
      decimal,
      minValue(value) {
        if (this.maintain_deposit == 0) {
          return minValue(1)(value)
        } else {
          return minValue(0)(value)
        }
      },
      required: requiredIf(function () {
        return this.maintain_deposit == 0;
      })
    },
    // is_default: {
    //   required
    // },
    // default_order: {
    //   required
    // },
    item_order: {
      required: requiredIf(function () {
        return this.default_order == false;
      })
    },
    reward_type: {
      required
    },
    cash: {
      required: requiredIf(function () {
        return this.reward_type == 'CASH';
      })
    },
    campaign_id: {
      required: requiredIf(function () {
        return this.reward_type == 'CASH';
      })
    },
    cs: {
      required: requiredIf(function () {
        return this.reward_type == 'CS';
      })
    },
    social_platform: {
      required: requiredIf(function () {
        return this.reward_type == 'CS';
      })
    }
  },
  watch : {
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.vipAddUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          vip_name: this.vip_name,
          deposit: this.deposit,
          turnover: this.turnover,
          maintain_deposit: this.maintain_deposit,
          maintain_turnover: this.maintain_turnover,
          // is_default: this.is_default,
          // default_order: this.default_order,
          is_default: false,
          default_order: true,
          item_order: this.item_order,
          reward_type: this.reward_type,
          cash: this.cash,
          campaign_id: this.campaign_id,
          cs: this.cs,
          social_platform: this.social_platform,
          audit_by: this.$store.getters.loginId
        };

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.addVip.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_vip", this.feedback.status);
                  this.$refs.addVip.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.vip_name = "";
      this.deposit = 0;
      this.turnover = 0;
      this.maintain_deposit = 0;
      this.maintain_turnover = 0;
      this.is_default = true;
      this.default_order = true;
      this.item_order = 0;
      this.reward_type = "";
      this.cash = "";
      this.campaign_id = "";
      this.cs = "";
      this.social_platform = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.vip_name.$el.focus();
    }
  }
};
</script>
